import React, { CSSProperties } from 'react';

import classnames from 'classnames';

import styles from './Tooltip.module.css';

export interface TooltipCSS extends CSSProperties {
  '--tooltipWidth': string;
}

type TooltipDirections = 'top' | 'right' | 'bottom' | 'left';

type TooltipProps = {
  text?: string;
  isDisabled?: boolean;
  direction?: TooltipDirections;
  width?: number;
  className?: string;
} & React.ComponentProps<'div'>;

const Tooltip = (props: TooltipProps) => {
  const {
    text,
    direction = 'right',
    isDisabled = false,
    children,
    className,
  } = props;

  const containerClassName = classnames(styles.Tooltip, className, {
    [styles.IsOpenTop]: direction === 'top',
    [styles.IsOpenRight]: direction === 'right',
    [styles.IsOpenBottom]: direction === 'bottom',
    [styles.IsOpenLeft]: direction === 'left',
  });

  if (isDisabled || !text) {
    return <>{children}</>;
  }

  return (
    <div data-testid="tooltip" data-text={text} className={containerClassName}>
      {children}
    </div>
  );
};

export default Tooltip;
